export enum LANGUAGES {
  EN = 'en',
  DE = 'de',
  ES = 'es',
  FR = 'fr',
  IT = 'it',
  PL = 'pl',
  RO = 'ro',
  CZ = 'cz',
  NL = 'nl',
  TR = 'tr',
  UK = 'uk',
  ZZ = 'zz',
}
